module.exports = __webpack_public_path__ + "static/media/Group8809.b0cf9856.svg";